



















































import { Vue, Prop, Component } from "vue-property-decorator"
import { WebinarInfo } from "@/models/WebinarInfo"
import VideoPlayer from "../shared/VideoPlayer.vue"
import InfoTab from "../shared/InfoTab.vue"
var SocialSharing = require("vue-social-sharing")
import FullVideoCompoment from "../shared/FullVideoComponent.vue"
import Carousel from "../Carousel.vue"
import "@/assets/horizontal.scss"
import { AwEventStore } from "@/models/AwEventStore"
import { AwEventType } from "@/models/AwEventType"
import { AnalyticsClient } from "@/services/AnalyticsService"
import { container } from "tsyringe"
Vue.use(SocialSharing)
@Component({
  components: {
    VideoPlayer,
    InfoTab,
    Carousel,
    FullVideoCompoment
  }
})
export default class HorizontalLayout extends Vue {
  @Prop() public webinarInfo!: WebinarInfo

  win = {
    width: window.innerWidth
  }
  created() {
    window.addEventListener("resize", this.handleResize)
  }
  mounted() {
    var key = this.$root.$data.identifierKey
    const self = this
    this.$root.$on("social_shares_open", function (network: any, url: string) {
      var temp = url.split("/")
      var momentid = temp[temp.length - 1]
      var event: AwEventStore = {
        eventType: AwEventType.MomentShared,
        momentId: parseInt(momentid)
      }
      const _analytics = container.resolve(AnalyticsClient)
      _analytics.register(event, key)
    })
  }
  public handleResize() {
    this.win.width = window.innerWidth
  }
}
